const inFlightRequests = new Map();
const recentResponses = new Map();

const normalizeValue = (value) => {
  if (Array.isArray(value)) return value.map(normalizeValue);
  if (!value || typeof value !== 'object') return value;

  return Object.keys(value)
    .sort()
    .reduce((result, key) => {
      result[key] = normalizeValue(value[key]);
      return result;
    }, {});
};

export const createRequestKey = (namespace, params = {}) =>
  `${namespace}:${JSON.stringify(normalizeValue(params))}`;

export const dedupeRequest = (key, requestFactory, { cacheTimeMs = 2000 } = {}) => {
  const cachedResponse = recentResponses.get(key);
  if (cachedResponse) {
    if (cachedResponse.expiresAt > Date.now()) {
      return Promise.resolve(cachedResponse.value);
    }
    recentResponses.delete(key);
  }

  const pendingRequest = inFlightRequests.get(key);
  if (pendingRequest) return pendingRequest;

  const request = Promise.resolve().then(requestFactory);
  inFlightRequests.set(key, request);

  const cleanup = () => {
    if (inFlightRequests.get(key) === request) {
      inFlightRequests.delete(key);
    }
  };
  request.then((value) => {
    // An explicit invalidation removes the request from inFlightRequests. Do
    // not let a response that was already running repopulate the stale cache.
    if (cacheTimeMs > 0 && inFlightRequests.get(key) === request) {
      recentResponses.set(key, {
        value,
        expiresAt: Date.now() + cacheTimeMs,
      });
    }
    cleanup();
  }, cleanup);

  return request;
};

export const clearDedupeRequestCache = (keyPrefix = '') => {
  const shouldDelete = (key) => !keyPrefix || key.startsWith(keyPrefix);

  for (const key of inFlightRequests.keys()) {
    if (shouldDelete(key)) inFlightRequests.delete(key);
  }

  for (const key of recentResponses.keys()) {
    if (shouldDelete(key)) recentResponses.delete(key);
  }
};
